import React from 'react';
import FormSuccess from 'components/finalWinner/FormSucces';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const FinalWinnerSuccesContainer = () => {
  const navigate = useNavigate();
  const { statusDataWinner } = useSelector((state) => state.finalWinner);

  const goHome = () => {
    navigate('/');
  };

  return (
    <>
      { statusDataWinner === '' ? goHome() : <FormSuccess /> }
    </>
  );
};

export default FinalWinnerSuccesContainer;
